import React, { memo, useEffect, useState } from 'react';
import { Input } from 'reactstrap';
import './index.css';

function Text(props) {
  const fieldName = props?.config?.renamed_block_parameter || '';

  const [inputValue, setInputValue] = useState(
    props?.config?.parameter_value || ''
  );

  const [touched, setTouched] = useState(false);

  useEffect(() => {
    setInputValue(props?.config?.parameter_value || '');
  }, [props?.config?.parameter_value]);

  const checkDisabled = (name) => {
    const disable = ['Agency Name', 'Product Category', 'Invoice Number'];
    return disable.includes(name);
  };

  const isDisabled = props?.isDisabled
    ? true
    : checkDisabled(fieldName);

  const showError =
    touched &&
    !isDisabled &&
    props?.ifRequired &&
    String(inputValue).trim() === '';

  const handleChange = (event) => {
    const value = event.target.value;

    setInputValue(value);
    props.handleInput?.(value);
  };

  return (
    <div className='textinput-genricpet-main'>
      {props?.showLabel && (
        <div className='Genericforms-text'>
          {fieldName}
          {props?.ifRequired && <sup>*</sup>}
        </div>
      )}

      <Input
        className='GenericPetforms-input'
        style={{
          backgroundColor: props?.formcolor
            ? props.formcolor
            : 'rgba(5, 138, 238, 0.1)',
          border: showError ? '1px solid red' : 'none'
        }}
        data-testid="genericinput"
        type='text'
        disabled={isDisabled}
        required={props?.ifRequired}
        value={inputValue}
        placeholder={`Enter ${fieldName}`}
        onChange={handleChange}
        onBlur={() => setTouched(true)}
      />
    </div>
  );
}

export default memo(Text);